import {ListItemIcon, styled} from '@mui/material';

const StyledListItemIcon = styled(ListItemIcon)`
	min-width: initial;
	color: ${({theme}) => theme.palette.primary.main};
`;

export {StyledListItemIcon};
